<nav class="navbar navbar-light" [ngStyle]="{
  'background-color': navbarColor || '#123f9a',
  'border-bottom': '1px solid #ccc'
}">
  <a class="logo-container" href="#">
    <img
      src="{{logoUrl}}"
      class="d-inline-block align-top"
      alt="Logo"
    />
    Infokanal
  </a>
  
  <button
    class="btn ms-auto me-4"
    [ngStyle]="{
      'color': navbarTextColor || '#fff'
    }"
    (click)="logout()"
    *ngIf="authService.user | async"
  >
    Logg ut
  </button>
</nav>

<div
  class="container"
  style="padding-top: 5rem"
  *ngIf="!(authService.user | async)"
>
  <div class="row">
    <div class="col-sm-9 col-md-7 col-lg-5 mx-auto">
      <div class="card card-signin my-5">
        <div class="card-body">
          <h5 class="card-title text-center">Logg inn</h5>
          <form class="form-signin">
            <div class="form-label-group">
              <input
                type="text"
                [(ngModel)]="email"
                class="form-control"
                name="email"
                placeholder="Email"
                autocomplete="username"
                required
                autofocus
              />
            </div>

            <div class="form-label-group">
              <input
                type="password"
                [(ngModel)]="password"
                name="password"
                class="form-control"
                placeholder="Passord"
                autocomplete="current-password"
                required
              />
            </div>
            <div
              class="error-message"
              *ngIf="authService.errorMsg"
              [innerHTML]="authService.errorMsg"
            >
            </div>
            <button
              class="btn text-uppercase"
              (click)="login()"
            >
              Logg inn
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
<app-carousel *ngIf="authService.user | async"></app-carousel>
